/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Card_Codebase_DescInputs */

const en_landing_card_codebase_desc = /** @type {(inputs: Landing_Card_Codebase_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Index an existing repo without uploading code, then plan the next step on top of it.`)
};

const id_landing_card_codebase_desc = /** @type {(inputs: Landing_Card_Codebase_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indeks repo yang sudah ada tanpa mengunggah kode, lalu rencanakan langkah berikutnya di atasnya.`)
};

/**
* | output |
* | --- |
* | "Index an existing repo without uploading code, then plan the next step on top of it." |
*
* @param {Landing_Card_Codebase_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const landing_card_codebase_desc = /** @type {((inputs?: Landing_Card_Codebase_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Card_Codebase_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_landing_card_codebase_desc(inputs)
	return en_landing_card_codebase_desc(inputs)
});